<template>
  <b-container class="highlight-container">

    <router-link to="/"><i class="fas fa-times btn--close"></i></router-link>

    <b-row>
      <b-col md="12" class="text-center px-0">
        <h1 v-scroll-reveal>Easy Access <br>to GO Transit & <br>Highways 407 & 401</h1>
        <div class="image-wrapper" v-scroll-reveal="{delay: 150}">
          <b-img src="/img/transit-highlight-banner.png" fluid center alt="New Transit"/>
        </div>
      </b-col>
    </b-row>

    <b-row class="background--white">
      <b-col md="10" offset-md="1" class="text-center">
        <h3 class="text--red text--extrabold mb-25"><a data-fancybox="video" href="https://player.vimeo.com/video/359571628?title=0&byline=0&portrait=0&transparent=0">WATCH VIDEO</a></h3>
        <p v-scroll-reveal>
          Your commute is one of the biggest considerations when choosing a new home. At New Seaton, you have access
          <br class="d-none d-xl-block">to
          some of the most convenient and comfortable ways to commute anywhere in the GTA.
        </p>
        <p v-scroll-reveal> A short drive north brings you to Hwy. 407, the GTA's ultimate express
          highway. The 401 is also close by, just <br class="d-none d-xl-block">south of New Seaton.
        </p>
        <p v-scroll-reveal>When you'd rather let someone else do the driving, the nearby Hwy. 407 GO
          Bus stop and Pickering GO Train <br class="d-none d-xl-block">station both provide great options to travel
          across the region in style.
        </p>
        <highlight-footer slot="register" />
      </b-col>
    </b-row>
    
  </b-container>
</template>

<script>
  import highlightFooter from '@/components/HighlightFooter';
  export default {
    components: {
      highlightFooter
    },
    mounted() {
      this.$root.layout.methods.triggerViewPortAnimation()
    },
    transition: {
      mode: 'out-in',
      css: false,
      appear: true,

      enter(el, done) {
        done()
      },
      leave(el, done) {
        done()
      },
    },
  }

</script>

<style scoped>

</style>
